import { useState } from 'react';
import { FormControl, Stack, FormLabel, Box } from '@chakra-ui/react';
import FieldToolTip from '@/components/forms/new/FieldToolTip';
import { Field } from 'formik';
import DropDown from '@/components/forms/new/formikFormFields/DropDown';
import {
    formLabelStyling,
    stackStyling,
} from '@/components/forms/new/formStyles';
import walkthroughIds from '../../walkthroughIds';

const UserPlatformDialPlanDropdown = ({
    setPlatformUser,
    errors,
    darkMode,
    dialPlans,
    platformIndex,
    platform,
}) => {
    const handleSelectChange = (item) => {
        setPlatformUser((prev) => {
            const newPlatformUsers = [...prev];
            const userProfiles = platform.userProfiles || [];
            newPlatformUsers[platformIndex] = {
                ...platform,
                userProfiles: [
                    {
                        ...userProfiles[0],
                        msDialPlanID: item.id,
                    },
                ],
            };
            return newPlatformUsers;
        });
    };

    const [isHovered, setIsHovered] = useState(false);

    return (
        <FormControl
            sx={{ margin: '0 !important' }}
            isInvalid={!!errors.dialPlan}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}>
            <Stack direction="row" sx={{ ...stackStyling(), width: '740px' }}>
                <Box width={190}>
                    <FormLabel sx={formLabelStyling(darkMode)}>
                        Dial Plan
                        <span style={{ color: '#e53e3e' }}>*</span>
                    </FormLabel>
                </Box>
                <Field
                    component={DropDown}
                    id="dialPlan"
                    name="dialPlan"
                    shownValue="name"
                    currentId={platform?.userProfiles[0]?.msDialPlanID}
                    handleSelectChange={handleSelectChange}
                    darkMode={darkMode}
                    data={dialPlans}
                    data-walkthroughid={walkthroughIds.edit.ufDialPlanDropdown}
                    validate={() => {
                        if (
                            platform?.userProfiles[0]?.msDialPlanID ===
                            undefined
                        ) {
                            return 'Please select a Dial Plan';
                        }
                    }}
                />
                {isHovered && (
                    <FieldToolTip
                        label="Dial Plan"
                        ariaLabel="users-dial-plan-dropdown-tooltip"
                        right="25px"
                        top="23px"
                    />
                )}
            </Stack>
        </FormControl>
    );
};

export default UserPlatformDialPlanDropdown;
